<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EHjg4c/tc-custom/9781398466647.jpg?1674927353068" alt="This image is the cover for the book Moorland Forensics - Aftershock"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moorland Forensics - Aftershock
      </h1>
      <p class="bookDescription body article font2">
        <p>The early years of the New Millennium. The High Veldt on the Dark Continent. A young family is ripped apart by a brutal, pre-meditated home invasion. The unknown assailants escaping into the night. Fifteen years later the South West of England is rocked by a series of devastating, suspected terrorist bombings, putting the nation on high alert. Investigations uncover connections to these tragedies with a catastrophic IRA car bombing in Northern Ireland a generation earlier. The team at Moorland Forensic Consultants battle conflicts of interests and personal crises as they work with government scientists and a compromised, faltering local law enforcement to bring the bombers to justice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie D. Jones
      </h2>
      
      <p class="authorDescription body article">Julie D. Jones was born in Bovey Tracey on the edge of Dartmoor and grew up near Kingsbridge in the South Hams in Devon. After finishing school Julie spent some time as an au pair in Bavaria. Graduating from The Gloucestershire Royal Hospital as a nurse, she emigrated to Australia working as a Nurse and also in the Music Industry. Aftershock is her fourth novel following on from the release in 2017 of Bound by Polaris, Devil’s Realm in 2019 and Conspiracy of Souls in 2021. Julie is a classically trained flautist and enjoys sailing and horse riding.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06e525ad